import React from "react";
import { Form, InputGroup } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import {
  Button,
  CustomInput,
  Description,
  SubTitle,
} from "../../Components/CustomComponents";
import AccountLayout from "../../Components/Layouts/AccountLayout";
import useLoginController from "../../controllers/AuthControllers/useLoginController";
import { ACCOUNT_ENUM } from "./Route";

export default function Login({ setPage, loginAs, setLoginAs }) {
  const { handleSubmit, control } = useForm();
  const portal = loginAs === "agent" ? "agent" : "admin";
  const {
    values: { loading },
    functions: { handleSignIn, handleForgotPasswordClick },
  } = useLoginController(setPage, portal);

  const panelTitle =
    portal === "agent" ? "Agent Panel" : "Admin Panel";

  return (
    <AccountLayout
      hasBackButton={true}
      handleBackButton={() => {
        setLoginAs(null);
        setPage(ACCOUNT_ENUM.ROLE_SELECT);
      }}
    >
      <SubTitle text={panelTitle} classes="mb-2" />

      <Form onSubmit={handleSubmit(handleSignIn)}>
        <Controller
          control={control}
          name="email"
          render={({ field: { onChange } }) => (
            <InputGroup
              className="mb-3"
              style={{
                width: "300px",
              }}
            >
              <CustomInput
                placeholder="Email"
                type="email"
                onChange={onChange}
              />
            </InputGroup>
          )}
        />
        <Controller
          control={control}
          name="password"
          render={({ field: { onChange } }) => (
            <InputGroup
              className="mb-3"
              style={{
                width: "300px",
              }}
            >
              <CustomInput
                type="password"
                placeholder="Password"
                onChange={onChange}
              />
            </InputGroup>
          )}
        />
        <Button
          text={loading ? "Signing in..." : "Login"}
          classes="mt-3 mb-2"
          type="submit"
          disabled={loading}
        />
      </Form>
      <Description
        classes="ms-auto cursor-pointer"
        text="Forgot Password ?"
        onClick={() => handleForgotPasswordClick()}
      />
    </AccountLayout>
  );
}
